import { EMAIL_THEME_CONTENT_SECTION_CLASSES, EMAIL_THEME_HIGHLIGHT_SECTION_CLASSES, EMAIL_THEME_ITEMS_SECTION_CLASSES, EMAIL_THEME_NOTICE_SECTION_CLASSES, emailThemeClassesToSelectors, } from '../email/emailSectionGroups.js';
export const DEFAULT_EMAIL_THEME_SPACING = {
    contentPadding: '40px 30px',
    headerPadding: '40px 30px',
    sectionGap: '28px',
    sectionPadding: '20px 24px',
    lineHeight: '1.6',
    buttonPadding: '16px 32px',
};
/** UI labels + CSS selectors — single source of truth for ThemeCustomizer and EmailCssService. */
export const EMAIL_THEME_SETTING_TARGETS = {
    'colors.primary': {
        label: 'Primary color',
        selectors: ['.estimate-number', '.invoice-number', '.option-price'],
        section: 'colors',
    },
    'colors.secondary': {
        label: 'Secondary color',
        selectors: ['.header', '.footer'],
        section: 'colors',
    },
    'colors.accent': {
        label: 'Accent / links',
        selectors: ['a:not(.cta-button)', '.estimate-number', '.option-price'],
        section: 'colors',
    },
    'colors.background': {
        label: 'Email background',
        selectors: ['body', '.container'],
        section: 'colors',
    },
    'colors.text': {
        label: 'Body text',
        selectors: ['body', 'p', '.content'],
        section: 'colors',
    },
    'colors.border': {
        label: 'Borders',
        selectors: ['.card', '.content-section', '.items-section'],
        section: 'colors',
    },
    'colors.headerBg': {
        label: 'Header background',
        selectors: ['.header', 'header'],
        section: 'colors',
    },
    'colors.footerBg': {
        label: 'Footer background',
        selectors: ['.footer', '.email-footer', 'footer', '.layout-footer-note'],
        section: 'colors',
    },
    'colors.buttonBg': {
        label: 'Primary button background',
        selectors: ['.cta-button'],
        section: 'colors',
    },
    'colors.buttonText': {
        label: 'Button text',
        selectors: ['.cta-button'],
        section: 'colors',
    },
    'colors.textMuted': {
        label: 'Muted / label text',
        selectors: ['.detail-label', '.amount-label', '.info-label', '.schedule-label'],
        section: 'colors',
    },
    'colors.sectionBg': {
        label: 'Section background',
        selectors: emailThemeClassesToSelectors([
            ...EMAIL_THEME_CONTENT_SECTION_CLASSES,
            ...EMAIL_THEME_ITEMS_SECTION_CLASSES,
            ...EMAIL_THEME_HIGHLIGHT_SECTION_CLASSES,
            ...EMAIL_THEME_NOTICE_SECTION_CLASSES,
        ]),
        section: 'colors',
    },
    'fonts.heading': {
        label: 'Heading font',
        selectors: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', '.header h1'],
        section: 'fonts',
    },
    'fonts.body': {
        label: 'Body font',
        selectors: ['body', '.content', 'p'],
        section: 'fonts',
    },
    'styles.spacing.contentPadding': {
        label: 'Content padding',
        selectors: ['.content'],
        section: 'spacing',
    },
    'styles.spacing.headerPadding': {
        label: 'Header padding',
        selectors: ['.header'],
        section: 'spacing',
    },
    'styles.spacing.sectionGap': {
        label: 'Section spacing',
        selectors: [
            ...emailThemeClassesToSelectors([
                ...EMAIL_THEME_CONTENT_SECTION_CLASSES,
                ...EMAIL_THEME_ITEMS_SECTION_CLASSES,
                ...EMAIL_THEME_HIGHLIGHT_SECTION_CLASSES,
            ]),
            '.cta-section',
            '.detail-row',
        ],
        section: 'spacing',
    },
    'styles.spacing.sectionPadding': {
        label: 'Section padding',
        selectors: emailThemeClassesToSelectors([
            ...EMAIL_THEME_CONTENT_SECTION_CLASSES,
            ...EMAIL_THEME_ITEMS_SECTION_CLASSES,
            ...EMAIL_THEME_HIGHLIGHT_SECTION_CLASSES,
        ]),
        section: 'spacing',
    },
    'styles.spacing.lineHeight': {
        label: 'Line height',
        selectors: ['body', '.content', 'p'],
        section: 'spacing',
    },
    'styles.spacing.buttonPadding': {
        label: 'Button padding',
        selectors: ['.cta-button', '.secondary-button'],
        section: 'spacing',
    },
    'styles.borderRadius': {
        label: 'Card radius',
        selectors: ['.container', '.card', '.estimate-card', '.invoice-card'],
        section: 'shape',
    },
    'styles.buttonRadius': {
        label: 'Button radius',
        selectors: ['.cta-button', '.secondary-button'],
        section: 'shape',
    },
    'styles.customCss': {
        label: 'Custom CSS',
        selectors: ['user-defined selectors'],
        section: 'custom',
    },
};
export const EMAIL_THEME_SECTION_SUBTITLES = {
    colors: 'Affects header, footer, buttons, body text, and accent elements',
    fonts: 'Affects headings (h1–h6) and body/content text',
    spacing: 'Affects .content, .header, section blocks, and buttons',
    shape: 'Affects cards, containers, and button corners',
    custom: 'Add rules for any class or id used in your template HTML',
};
export function getEmailThemeSettingTarget(key) {
    return EMAIL_THEME_SETTING_TARGETS[key];
}
/** Resolve theme id: explicit template.themeId (preview/editor) → business emailThemeId */
export function resolveEmailThemeId(templateThemeId, businessEmailThemeId) {
    return templateThemeId ?? businessEmailThemeId;
}
export const MAX_EMAIL_THEME_CUSTOM_CSS_LENGTH = 8192;
/** Strip unsafe patterns from user custom CSS (email themes). */
export function sanitizeEmailThemeCustomCss(css) {
    if (!css?.trim())
        return '';
    let result = css.trim();
    if (result.length > MAX_EMAIL_THEME_CUSTOM_CSS_LENGTH) {
        result = result.slice(0, MAX_EMAIL_THEME_CUSTOM_CSS_LENGTH);
    }
    result = result.replace(/<script[\s\S]*?<\/script>/gi, '');
    result = result.replace(/@import[^;]+;/gi, '');
    return result;
}
//# sourceMappingURL=emailTheme.js.map